import React from "react";
var __jsx = React.createElement;
import stl from "./SellTradeHero.module.css";
import { CMSImageHelper } from "@/utils/CMSHelpers";
import { useCMS } from "@hooks/useCMS";
var SellTradeHero = function SellTradeHero(sellTradeHero) {
  var _sellTradeHero$image, _sellTradeHero$cta, _sellTradeHero$cta2, _sellTradeHero$cta3, _sellTradeHero$cta4, _sellTradeHero$image$, _sellTradeHero$image2;
  var _useCMS = useCMS(),
    urlHelper = _useCMS.urlHelper;
  var heroImage = CMSImageHelper(sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$image = sellTradeHero.image) === null || _sellTradeHero$image === void 0 ? void 0 : _sellTradeHero$image.url);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container,
    style: {
      backgroundColor: sellTradeHero.bg_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.flex].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.infoArea
  }, /*#__PURE__*/React.createElement("h1", {
    dangerouslySetInnerHTML: {
      __html: sellTradeHero === null || sellTradeHero === void 0 ? void 0 : sellTradeHero.label1
    }
  }), (sellTradeHero === null || sellTradeHero === void 0 ? void 0 : sellTradeHero.label2) && /*#__PURE__*/React.createElement("strong", {
    dangerouslySetInnerHTML: {
      __html: sellTradeHero === null || sellTradeHero === void 0 ? void 0 : sellTradeHero.label2
    }
  }), (sellTradeHero === null || sellTradeHero === void 0 ? void 0 : sellTradeHero.label3) && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: sellTradeHero === null || sellTradeHero === void 0 ? void 0 : sellTradeHero.label3
    }
  }), (sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$cta = sellTradeHero.cta) === null || _sellTradeHero$cta === void 0 ? void 0 : _sellTradeHero$cta.url) && (sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$cta2 = sellTradeHero.cta) === null || _sellTradeHero$cta2 === void 0 ? void 0 : _sellTradeHero$cta2.text) && /*#__PURE__*/React.createElement("a", {
    className: ["m-hide", "blueBtn"].join(" "),
    href: urlHelper(sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$cta3 = sellTradeHero.cta) === null || _sellTradeHero$cta3 === void 0 ? void 0 : _sellTradeHero$cta3.url)
  }, sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$cta4 = sellTradeHero.cta) === null || _sellTradeHero$cta4 === void 0 ? void 0 : _sellTradeHero$cta4.text))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.imageHolder
  }, /*#__PURE__*/React.createElement("img", {
    src: heroImage,
    width: 528,
    alt: (_sellTradeHero$image$ = sellTradeHero === null || sellTradeHero === void 0 ? void 0 : (_sellTradeHero$image2 = sellTradeHero.image) === null || _sellTradeHero$image2 === void 0 ? void 0 : _sellTradeHero$image2.caption) !== null && _sellTradeHero$image$ !== void 0 ? _sellTradeHero$image$ : heroImage,
    loading: sellTradeHero.image_loading_behavior
  }))))));
};
export default SellTradeHero;